<app-close (click)="closeModal()"></app-close>
<iframe *ngIf="pdf == 'Data Exchange Consent'" src="../../../../../assets/legal/Data_Exchange_Consent.pdf"></iframe>
<iframe *ngIf="pdf == 'Privacy Policy'" src="../../../../../assets/legal/Brain_Evolved_Inc_Privacy_Policy.pdf"></iframe>
<iframe *ngIf="pdf == 'Disclaimers'" src="../../../../../assets/legal/Brain_Evolved_Disclaimers.pdf"></iframe>
